import styled from '@emotion/styled';

export const StyledPropertyItemImgWrapper = styled.figure`
  background-color: #ebebeb;
  background-image:
    linear-gradient(45deg, #fff 25%, transparent 25%),
    linear-gradient(-45deg, #fff 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #fff 75%),
    linear-gradient(-45deg, transparent 75%, #fff 75%);
  background-size: 40px 40px;
  background-position:
    0 0,
    0 20px,
    20px -20px,
    -20px 0px;
  width: 100%;
  max-width: 100%;
  height: 200px;
  margin: 0;
  padding: 0;
  overflow: hidden;
`;
